import React, { memo } from 'react';
import { View } from 'react-native';
import styles from "@stylesheet";
import FooterBar from "@navigation/FooterBar/FooterBar";
import AddCompanyModal from "@components/modals/AddCompanyModal/AddCompanyModal.web";
import LangModal from "@components/modals/LanguageModal/LangModal";
import CommModal from "@components/modals/CommunityModal/CommModal";
import FeedbackModal from "@components/modals/FeedbackModal/FeedBackModal";
import { useSelector } from 'react-redux';
import { DefaultRootState } from '@reduxLocal/persistState';

/**
 * Extracted FooterModals component
 * Groups footer bar and related modals to prevent parent re-renders
 */
const FooterModals: React.FC = () => {
  const easyMode = useSelector((state: DefaultRootState) => state.UI.easyMode);

  return (
    <View style={{ flexDirection: 'column-reverse' }}>
      <View style={[styles.centerEverything, {
        maxHeight: 0,
        alignSelf: 'stretch',
        flex: 1,
        flexDirection: 'row',
        minWidth: '100%',
        paddingHorizontal: '20%',
        top: 40,
        zIndex: 100000
      }]}>
        {!easyMode && (
        <FooterBar />
        )}
        <AddCompanyModal />
        <LangModal />
        <CommModal />
        <FeedbackModal />
      </View>
    </View>
  );
};

export default memo(FooterModals);

